import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as engagementCharterComponent from '../engagement-charter-component'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: engagementCharterComponent.RESOURCE.payload.dimension.partialId,
      partialId: engagementCharterComponent.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The kind of source document this component is.',
    isOptional: false,
    name: 'Component Type',
    partialId: PartialId.Standard.create('component_type'),
    type: {
      enumId: core.dms.models.Enum.Id.from(
        enums.engagementCharterComponentKind.RESOURCE.payload,
      ),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
